import { IconClose } from '@hulu-react-style-components/icons';
import { Modal } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';
import React, { RefObject } from 'react';

import Button from '../../Button';
import { ButtonContainer, Container, Header, StyledButton, StyledText, Text, Title } from '../styled';
import { ModalType } from './types';

type ConfirmModalType = {
  visible: boolean;
  title: string | React.ReactNode;
  text: string | React.ReactNode;
  textWidth?: string;
  onConfirm?: () => Promise<void> | void;
  onDeny: () => void;
  loading?: boolean;
  className?: string;
  modalType?: ModalType;
  textStyle?: Variant;
  denyButtonText?: string;
  confirmButtonText?: string;
  width?: string;
  inputRef?: RefObject<HTMLDivElement>;
};

const ConfirmModal = ({
  visible,
  title,
  text,
  textWidth,
  onConfirm = (): void => {},
  onDeny,
  loading,
  className,
  modalType = ModalType.yesNo,
  denyButtonText = 'No',
  confirmButtonText = 'Yes',
  width,
  inputRef,
}: ConfirmModalType): JSX.Element => {
  return (
    <Modal open={visible} onClose={onDeny} data-testid="confirmationModal" className={className} ref={inputRef}>
      <Container $width={width}>
        <Header>
          <Title variant="h4">{title}</Title>
          <IconClose onClick={onDeny} />
        </Header>
        <Text>
          <StyledText $textWidth={textWidth} data-testid="modalText">
            {text}
          </StyledText>
        </Text>
        {modalType === ModalType.yesNo && (
          <ButtonContainer>
            <Button variant="outlined" onClick={onDeny} data-testid="modalCancelButton">
              {denyButtonText}
            </Button>
            <StyledButton
              onClick={onConfirm}
              disabled={loading}
              isLoading={loading}
              className="primary"
              data-testid="modalConfirmButton"
            >
              {confirmButtonText}
            </StyledButton>
          </ButtonContainer>
        )}
        {modalType === ModalType.close && (
          <div>
            <Button onClick={onDeny} data-testid="modalCloseButton" className="primary">
              Close
            </Button>
          </div>
        )}
      </Container>
    </Modal>
  );
};

export default ConfirmModal;
